<template>
  <div :class="['process-content','process-editor', 'layout_type_1' ]">
    <!-- layout_type_1 : table 접히고 editor만 보임 -->
    <!-- layout_type_2 : editor 접히고 table만 보임 -->
    <!-- layout_type_3 : editor, table 전부 보임 -->
    <ProcessTop
      :readOnly="readOnly"
    ></ProcessTop>
    <LNBNew v-if="!readOnly"/>
    <IssueList :experimentFlag="false"/>

    <Editor v-if="!readOnly"
            :editKey="editKey"
    />
    <ReadOnlyEditor v-if="readOnly"/>

    <SideBar/>
    <DocumentOption v-if="!readOnly"/>
    <!-- <TagOptionPopTagAddList /> -->

    <ProcessReadOnlyBtmOption
        v-if="readOnly"
        @editProcess="editProcess"
        :processType="processType"
    />

    <ProcessReadOnlyDocumentOption
        v-if="readOnly"
        :apiType="`process`"
    />

    <TemplatePopup/>
    <ApprovalRequestPopup/>
    <!-- <TagWriteComp /> -->

  </div>
</template>

<script>
let num = 0;
import {ref, onMounted, watch} from 'vue'
import ProcessTop from './Top';
import Editor from "@nav_process/Editor";
import ReadOnlyEditor from "@nav_process/Editor/index_readonly";
import SideBar from "@nav_process/SideBar";

import LNBNew from "@nav_process/LNB";

import DocumentOption from "@nav_process/Editor/documentOption"
import CommNew from "@processEditor/CommNew";
import TagOptionPopTagAddList from '@components/TagAddPop/TagOptionPopTagAddList' ;
import TemplatePopup from '@components/TemplatePopup' ;
import ApprovalRequestPopup from '@components/ApprovalRequestPopup' ;
import IssueList from '../protocolEditor/IssueList';
import ProcessReadOnlyBtmOption from '@common/ProcessReadOnlyBtmOption' ;
import ProcessReadOnlyDocumentOption from "@nav_process/Editor/ReadOnlyDocumentOption"
import ExperimentResult from "@/components/experimentResult/ExperimentResult";

import {createNamespacedHelpers} from 'vuex';
const Hub = createNamespacedHelpers('Hub');
import {v4} from "uuid";

export default {
  mixins: [CommNew],
  components: {
    ExperimentResult,
    ProcessTop,
    LNBNew,
    Editor,
    ReadOnlyEditor,
    SideBar,
    DocumentOption,
    TagOptionPopTagAddList,
    TemplatePopup,
    ApprovalRequestPopup,
    IssueList,
    // TagWriteComp ,
    ProcessReadOnlyBtmOption,
    ProcessReadOnlyDocumentOption,
  },
  data() {
    return {
      firstBln: false,
      readOnly: true,
      editKey: null,
      processType : null,
    }
  },
  computed: {
    editorLayoutClass() {
      return this.$store.getters["Hub/getEditorLayoutClass"];
    },
  },
  async mounted() {
    this.setProcessReadOnly(true);
    if (this.$route.query.processId == "NaN") {
      this.$router.push({path: `/process/gate`});
      return;
    }

    let {user, $route: {query}} = this;
    if(!this.user || (!this.user.admin && !this.user.committee && !this.user.super && !this.user.generalManager)){
      alert('잘못된 접근입니다.');
      this.$router.push({
        path : '/experiment/gate' ,
        query : {
          editorType: 'gate'
        }
      }) ;
      return;
    }
    this.setInitInfo({user, query});
    await this.setProcess_N_UserInfo();
    this.readonlyCheck();
    await this.initElements();
    this.firstBln = true;
  },
  watch: {
    PROCESS_INFO() {
      if (!this.firstBln) return;
      // console.log(' ------. this.firstBln : ' , this.firstBln ) ; 
      this.readonlyCheck()
    },
  },
  methods: {
    readonlyCheck() {
      this.readOnly = this.getProcessReadOnly;
      this.processType = this.PROCESS_INFO.processType
      //TODO 권한으로 제어
      if (this.PROCESS_INFO.processType === 'ONLY_PROTOCOL' || this.$route.query.menuType=='researcher') {
        this.readOnly = true;
      }

    },

    async editProcess() {
      try {
        const key = v4();
        let keyResponse;
        //console.log('this.editKey = {}',this.editKey)
        const response = await this.$wApi.simultaneous.editCheck({
          relativeId: this.$route.query.processId,
          editType: "PROCESS",
          validTime: Math.floor(this.editDuration / 1000),
        });
        if (response.isEditMode) {
          if (this.user.id == response.userResBody.id && response.editKey != null && response.editKey != "" && response.count == 0 && !response.editable) {
            //유저가 같음 && editStatus가 신규 상태가 아님 && 유효시간 지난 status가 없음(수정중! count=0) && editable == false => 어느 세션 유지할건지 confirm
            const confirmResult = await confirm("다른 브라우저에서 수정중입니다.<br/> 수정화면을 대체하시겠습니까?");
            if (confirmResult) {
              //key 발급(update)
              keyResponse = await this.$wApi.simultaneous.statusUpdate({
                relativeId: this.$route.query.processId,
                editType: "PROCESS",
                editKey: key,
                editable : false, //수정불가능상태로 변경
              });
            } else {
              //수정불가
              this.readOnly = true;
              return;
            }
          } else {
            //수정가능 상태이거나 또는 유저가 다르거나 또는 editStatus가 신규 상태 또는 유효시간 지났을경우 => key 발급(update).
            keyResponse = await this.$wApi.simultaneous.statusUpdate({
              relativeId: this.$route.query.processId,
              editType: "PROCESS",
              editKey: key,
              editable : false, //수정불가능상태로 변경
            });
          }
          //수정가능
          if (!keyResponse.error) {
            this.editKey = key;
            this.readOnly = false;
          }
        } else {
          //수정불가
          this.readOnly = true;
          alert(`현재 ${response.userResBody.userName}님이 수정중입니다.`)
        }
      } catch (e) {
        this.readOnly = true;
        console.log(e);
      }
    },
  },
}
</script>

<style lang="scss">
.process-editor .process-editor-top {
  grid-area: top;
}
</style>

<style lang="scss" scoped>
  @import "@/style/new/css/cyl.common.css";
</style>